import { readWorkspace, readWorkspaces, readWorkspaceDefaults } from './read'
import { updateWorkspaceDefaults } from './update'

export const workspaces = {
  readSingle: readWorkspace,
  readCollection: readWorkspaces,
  readDefaults: readWorkspaceDefaults,
  updateDefaults: updateWorkspaceDefaults,
}
